import { Text } from '@/components/Text';

import ResponsiveText from '@/components/SharedComponents/ResponsiveText/ResponsiveText';

export function WordSquare({ word, correctWords }) {
  const wordsSplit = word.split(' ');
  return (
    <ResponsiveText>
      {wordsSplit.map((eachItem, i) => {
        const isShown = correctWords[i] === eachItem;
        const className = !isShown ? 'text-transparent' : 'text-black';
        return (
          <Text
            className={className + ' font-abz'}
            key={i}
            isResponsiveText={true}
          >
            {eachItem + ' '}
          </Text>
        );
      })}
    </ResponsiveText>
  );
}
